module.exports = __webpack_public_path__ + "static/media/SC.2f9628aa.svg";